import type { FC } from 'react';
import React from 'react';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import { Stack } from '@mui/material';

import type { BaseSnackbarProps } from '../index';
import BaseSnackbar from '../index';

import { styles } from './index.styles';

type ErrorSnackbarProps = Omit<BaseSnackbarProps, 'leftColumn'>;

const ErrorSnackbar: FC<ErrorSnackbarProps> = ({
  onClose,
  open,
  snackbarProps,
  snackbarContentProps,
  title,
  message,
  testId,
}) => (
  <BaseSnackbar
    open={open}
    onClose={onClose}
    title={title}
    message={message}
    snackbarProps={snackbarProps}
    snackbarContentProps={snackbarContentProps}
    testId={testId}
    leftColumn={
      <Stack sx={styles.errorSnackbarIcon}>
        <ErrorOutline />
      </Stack>
    }
  />
);

export default ErrorSnackbar;
